var map = {
	"./fi-cloudpro.png": "308c",
	"./fi-cloudskills.png": "a899",
	"./fi-digiskills.png": "94e3",
	"./fi-eduhouse-guide.png": "f46f",
	"./fi-hr-p.png": "10ba",
	"./fi-johtaminen.png": "ee70",
	"./fi-julkishallinto.png": "aac1",
	"./fi-klt-valmennus.png": "d9a4",
	"./fi-myynti-2.png": "5538",
	"./fi-oppilaitos.png": "07e5",
	"./fi-pht-valmennus.png": "d1e8",
	"./fi-powerskills.png": "78a3",
	"./fi-pp-mepco-package.png": "820f",
	"./fi-talous.png": "dfcb",
	"./fi-tekoaly.png": "8069",
	"./fi-tietoturva.png": "8267",
	"./fi-tyoaikaratkaisut.png": "b9cb",
	"./no-adobe.png": "4278",
	"./no-baerekraft.png": "ba1c",
	"./no-digiskills-eng.png": "77b0",
	"./no-eduhouse-internal.png": "79c2",
	"./no-gpa.png": "b480",
	"./no-ki.png": "9151",
	"./no-management.png": "ce27",
	"./no-o365.png": "f115",
	"./no-okonomikurs.png": "0033",
	"./no-personligutvikling.png": "2c85",
	"./se-ai.png": "6500",
	"./se-annat.png": "2845",
	"./se-design.png": "9d43",
	"./se-english-digiskills.png": "8d91",
	"./se-english-management.png": "0efb7",
	"./se-english-pro.png": "9471",
	"./se-hr.png": "2361",
	"./se-ledarskap.png": "3e42",
	"./se-list-a.png": "dde5",
	"./se-lon.png": "91e73",
	"./se-office-skills.png": "9071",
	"./se-redovisning.png": "f844",
	"./se-skatt-moms.png": "0418",
	"./se-valbefinnande.png": "0f9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7cfa";